<template>
  <div>
    <div
      class="mb-3 flex w-full flex-col items-end justify-between gap-y-2 md:flex-row md:items-start"
    >
      <h3
        class="w-full border-l-4 border-p-500 pl-2 text-xl font-bold capitalize text-s-900 md:w-auto lg:text-3xl"
      >
        Sustainability Index
      </h3>
      <LinkWithAnimation
        v-if="isAuthorized"
        text="View More"
        class="flex-shrink-0 text-sm font-semibold md:text-base"
        :url="getRoute"
      />
      <ButtonContactUs
        v-else
        text="Contact Us"
        variant="clean"
        :services="checkboxesEsg"
        class="!text-sm !text-black"
      />
    </div>
    <SustainabilityIndexTable
      :sustainability-indexes="sustainabilityIndexes"
      :product="slug"
      @is-authorized="handleIsAuthorized"
    />
  </div>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue'
import { useRoute } from 'vue-router'
import { ESG } from '~/constants/services/constants'
import LinkWithAnimation from '~/components/shared/common/LinkWithAnimation.vue'
import ButtonContactUs from '~/components/shared/common/ButtonContactUs.vue'
import SustainabilityIndexTable from '~/components/sustainability/SustainabilityIndexTable.vue'

const props = withDefaults(
  defineProps<{
    sustainabilityIndexes: Array<any>
    slug: string
    checkbox?: string
  }>(),
  {
    checkbox: '',
  },
)

const isAuthorized = ref(false)
const route = useRoute()

const checkboxesEsg = computed(() => {
  return props.checkbox ? [props.checkbox, ESG.checkbox] : [ESG.checkbox]
})

const getRoute = computed(() => {
  const path = route.path.split('/portal')[0]
  return `${path}/sustainability/sustainability-index`
})

const handleIsAuthorized = (authorized: boolean) => {
  isAuthorized.value = authorized
}
</script>
